module.exports = __webpack_public_path__ + "static/media/earn-exp.181e856b.png";